import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { defineServerConfig } from "./serverConfig";
import { AccountGate } from "./components/AccountGate";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found in index.html");

const serverConfig = defineServerConfig();
createRoot(container).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <AccountGate serverConfig={serverConfig}><App serverConfig={serverConfig} /></AccountGate>
    </ThemeProvider>
  </StrictMode>,
);
